import Api from '@/services/Api'
// import { log } from 'util';

export default {
  index(search) {
    return Api().get('eracun', {
      params: search
    })
  },
  indexlist(search) {
    return Api().get('eracun/list', {
      params: search
    })
  },
  createubl(doc) {
    return Api().post('eracun/createubl', doc)
  },
  show(documentid) {
    return Api().get(`eracun/${documentid}`)
  },
  post(newdocument) {
    return Api().post('eracun', newdocument)
  },
  put(eracun) {
    return Api().put(`eracun/${eracun.id}`, eracun)
  },
  delete(documentid) {
    return Api().delete(`eracun/${documentid}`)
  },
  copy(query) {
    return Api().get(`eracun/copy`, {
      params: query
    })
  },
  choose(query) {
    return Api().get('eracun/choose', {
      params: query
    })
  }
}